import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { EditorState, Modifier } from 'draft-js';
import classNames from 'classnames';

// eslint-disable-next-line react/no-multi-comp
class ResetControl extends Component {
  constructor(props) {
    super(props);
    this.state = {
      expanded: false,
    };
    this.onClick = this.onClick.bind(this);
  }

  onClick() {
    this.props.onReset();
  }

   render() {
    const {
      config: { className },
    } = this.props;
    return (
      <div
        className="rdw-inline-wrapper"
      >
        <div
          className={classNames(
            'rdw-option-wrapper',
            className,
          )}
          onClick={this.onClick}
          title="Reset Default"
        >
          <span>Reset Default</span>
        </div>
      </div>
    );
  }
}

ResetControl.propTypes = {
  editorState: PropTypes.shape({
    getSelection: PropTypes.func,
    getCurrentContent: PropTypes.func,
    getLastChangeType: PropTypes.func,
  }).isRequired,
  onReset: PropTypes.func,
  modalHandler: PropTypes.shape(),
  config: PropTypes.shape({}),
  defaultText: PropTypes.string,
};
ResetControl.defaultProps = {
  config: {},
  onReset: () => {},
  defaultText: null,
};

export default ResetControl;
